import Preload from '../components/Preload';
import FadeIn from '../components/FadeIn';

function VirtualWalkthrough() {
    const preloadResources = {
        images: [
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/venue-classic500.jpg`,
                media: "(min-width: 768px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/venue-classic250.jpg`, 
                media: "(max-width: 767px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/venue-modern500.jpg`,
                media: "(min-width: 768px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/venue-modern250.jpg`,
                media: "(max-width: 767px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/venue-industrial500.jpg`,
                media: "(min-width: 768px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/venue-industrial250.jpg`,
                media: "(max-width: 767px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/real-estate-corp500.jpg`,
                media: "(min-width: 768px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/real-estate-corp250.jpg`,
                media: "(max-width: 767px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/real-estate-dev500.jpg`,
                media: "(min-width: 768px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/real-estate-dev250.jpg`,
                media: "(max-width: 767px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/real-estate-home500.jpg`,
                media: "(min-width: 768px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/real-estate-home250.jpg`,
                media: "(max-width: 767px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/hotel-resort01-500.jpg`,
                media: "(min-width: 768px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/hotel-resort01-250.jpg`,
                media: "(max-width: 767px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/hotel-resort02-500.jpg`,
                media: "(min-width: 768px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/hotel-resort02-250.jpg`,
                media: "(max-width: 767px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/hotel-resort03-500.jpg`,
                media: "(min-width: 768px)"
            },
            {
                src: `${process.env.PUBLIC_URL}/walkthrough/hotel-resort03-250.jpg`,
                media: "(max-width: 767px)"
            }
        ]
    };
    return (
        <>
            <Preload {...preloadResources} />
            <title>Virtual Walkthrough Solutions - vidi3D Interactive Space Visualization</title>
            <meta name="description" content="Experience immersive virtual walkthroughs for venues, event spaces and properties. Our interactive 3D visualization tools help showcase your space's full potential." />
            <meta name="keywords" content="virtual walkthrough, 3D visualization, venue tours, event space technology, interactive property tours" />
            <meta property="og:title" content="Virtual Walkthrough Solutions - vidi3D Interactive Space Visualization" />
            <meta property="og:description" content="Transform how you showcase venues and spaces with vidi3D's immersive virtual walkthrough technology. Interactive 3D visualization for properties and event spaces." />
            <meta property="og:type" content="website" />
            <meta property="og:image" content={`${process.env.PUBLIC_URL}/walkthrough/venue-modern500.jpg`} />
            <link rel="canonical" href="https://vidi3d.com/virtual-walkthrough" />
            <div className="flex flex-col items-center w-full max-w-[1200px] p-4 mx-auto">
                <FadeIn delay={0.25}>
                    <h1 className="text-6xl font-bold text-brand text-center py-10">A sales toolkit  for all venues, spaces, layouts and services</h1>
                </FadeIn>
                <FadeIn delay={0.5}>
                    <p className="text-brand-dark text-center text-xl">Unleash your space's full potential with immersive walkthroughs that captivate and 'wow' your clients. Our virtual tours are designed to showcase your space in a way that is both engaging and informative. Whether you're looking to sell your property, showcase your business, or simply provide a unique experience for your clients, our virtual tours are the perfect solution.</p>
                </FadeIn>
            <div className="relative w-full mt-8">
                <FadeIn delay={0.5}>
                <div className="flex w-full h-[400px]">
                    {/* Classic Image */}
                    <div className="relative flex-1">
                        <picture>
                            <source media="(min-width: 768px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/venue-classic500.jpg`} />
                            <source media="(max-width: 767px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/venue-classic250.jpg`} />
                            <img 
                                src={`${process.env.PUBLIC_URL}/walkthrough/venue-classic500.jpg`}
                                alt="Classic venue style"
                                className="w-full h-full object-cover"
                            />
                        </picture>
                        <div className="absolute bottom-6 left-0 w-full text-center text-white text-xl font-semibold">
                            Classic
                        </div>
                    </div>

                    {/* Modern Image */}
                    <div className="relative flex-1">
                        <picture>
                            <source media="(min-width: 768px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/venue-modern500.jpg`} />
                            <source media="(max-width: 767px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/venue-modern250.jpg`} />
                            <img 
                                src={`${process.env.PUBLIC_URL}/walkthrough/venue-modern500.jpg`}
                                alt="Modern venue style"
                                className="w-full h-full object-cover"
                            />
                        </picture>
                        <div className="absolute bottom-6 left-0 w-full text-center text-white text-xl font-semibold">
                            Modern
                        </div>
                    </div>

                    {/* Industrial Image */}
                    <div className="relative flex-1">
                        <picture>
                            <source media="(min-width: 768px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/venue-industrial500.jpg`} />
                            <source media="(max-width: 767px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/venue-industrial250.jpg`} />
                            <img 
                                src={`${process.env.PUBLIC_URL}/walkthrough/venue-industrial500.jpg`}
                                alt="Industrial venue style"
                                className="w-full h-full object-cover"
                            />
                        </picture>
                        <div className="absolute bottom-6 left-0 w-full text-center text-white text-xl font-semibold">
                            Industrial
                        </div>
                    </div>

                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-r from-brand/60 to-transparent"></div>

                    {/* Centered Text */}
                    <div className="absolute inset-0 flex items-center justify-center">
                        <h2 className="text-4xl font-bold text-white">venues & event spaces</h2>
                    </div>
                </div>
                </FadeIn>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Column 1 */}
                    <FadeIn delay={0.15}>
                    <div className="flex flex-col items-center text-center">
                        <svg className="w-16 h-16 text-brand mb-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 9V3H15M21 3L13 11M10 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21H17C18.1046 21 19 20.1046 19 19V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <h3 className="text-2xl font-bold text-brand-dark mb-2">Transform Your Venue Tours</h3>
                        <p className="text-gray-600">Allow clients to explore your event space with a virtual experience that feels as real as being there</p>
                    </div>
                    </FadeIn>

                    {/* Column 2 */}
                    <FadeIn delay={0.3}>
                    <div className="flex flex-col items-center text-center">
                        <svg className="w-16 h-16 text-brand mb-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V7C20 7.55228 19.5523 8 19 8H5C4.44772 8 4 7.55228 4 7V5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            <path d="M4 13C4 12.4477 4.44772 12 5 12H19C19.5523 12 20 12.4477 20 13V15C20 15.5523 19.5523 16 19 16H5C4.44772 16 4 15.5523 4 15V13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            <path d="M4 19H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                        <h3 className="text-2xl font-bold text-brand-dark mb-2">Showcase Multiple Event Layouts</h3>
                        <p className="text-gray-600">Display versatile setups for weddings, corporate events, and more, helping clients envision their perfect event</p>
                    </div>
                    </FadeIn>

                    {/* Column 3 */}
                    <FadeIn delay={0.45}>
                    <div className="flex flex-col items-center text-center">
                        <svg className="w-16 h-16 text-brand mb-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <h3 className="text-2xl font-bold text-brand-dark mb-2">Simplify the Booking Process</h3>
                            <p className="text-gray-600">Engage clients from anywhere with an immersive tour that accelerates decision-making and bookings</p>
                        </div>
                    </FadeIn>
                </div>
                <FadeIn delay={0.5}>
                    <div className="text-center mt-12">
                        <a href="/contact" className="inline-block px-8 py-3 bg-brand text-white font-semibold rounded-lg hover:bg-brand-dark transition-colors duration-200">
                            Book a Call
                        </a>
                    </div>
                </FadeIn>
            </div>

            <FadeIn delay={0.5}>
            <div className="relative w-full mt-8">
                <div className="flex w-full h-[400px]">
                    {/* Corporate Architecture Image */}
                    <div className="relative flex-1">
                        <picture>
                            <source media="(min-width: 768px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/real-estate-corp500.jpg`} />
                            <source media="(max-width: 767px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/real-estate-corp250.jpg`} />
                            <img 
                                src={`${process.env.PUBLIC_URL}/walkthrough/real-estate-corp500.jpg`}
                                alt="Corporate architecture style"
                                className="w-full h-full object-cover"
                            />
                        </picture>
                        <div className="absolute bottom-6 left-0 w-full text-center text-white text-xl font-semibold">
                            Corporate Architecture
                        </div>
                    </div>

                    {/* Real Estate Development Image */}
                    <div className="relative flex-1">
                        <picture>
                            <source media="(min-width: 768px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/real-estate-dev500.jpg`} />
                            <source media="(max-width: 767px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/real-estate-dev250.jpg`} />
                            <img 
                                src={`${process.env.PUBLIC_URL}/walkthrough/real-estate-dev500.jpg`}
                                alt="Real estate development style"
                                className="w-full h-full object-cover"
                            />
                        </picture>
                        <div className="absolute bottom-6 left-0 w-full text-center text-white text-xl font-semibold">
                            Real Estate Development
                        </div>
                    </div>

                    {/* Residential Image */}
                    <div className="relative flex-1">
                        <picture>
                            <source media="(min-width: 768px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/real-estate-home500.jpg`} />
                            <source media="(max-width: 767px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/real-estate-home250.jpg`} />
                            <img 
                                src={`${process.env.PUBLIC_URL}/walkthrough/real-estate-home500.jpg`}
                                alt="Residential style"
                                className="w-full h-full object-cover"
                            />
                        </picture>
                        <div className="absolute bottom-6 left-0 w-full text-center text-white text-xl font-semibold">
                            Residential
                        </div>
                    </div>

                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-r from-brand/60 to-transparent"></div>

                    {/* Centered Text */}
                    <div className="absolute inset-0 flex items-center justify-center">
                        <h2 className="text-4xl font-bold text-white">real estate & architecture</h2>
                    </div>
                </div>
            </div>
            </FadeIn>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Column 1 */}
                    <FadeIn delay={0.15}>
                    <div className="text-center">
                        <div className="flex justify-center mb-4">
                            <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M9 22V12H15V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <h3 className="text-xl font-semibold mb-2">Bring Blueprints to Life</h3>
                        <p className="text-gray-600">Turn plans into stunning virtual walkthroughs that allow buyers to visualize every detail before completion</p>
                    </div>
                    </FadeIn>

                    {/* Column 2 */}
                    <FadeIn delay={0.3}>
                    <div className="text-center">
                        <div className="flex justify-center mb-4">
                            <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M12 16L16 12L12 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M8 12H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <h3 className="text-xl font-semibold mb-2">Highlight Key Architectural Features</h3>
                            <p className="text-gray-600">Showcase the unique design elements and layout of your properties with lifelike accuracy</p>
                        </div>
                    </FadeIn>

                    {/* Column 3 */}
                    <FadeIn delay={0.45}>
                    <div className="text-center">
                        <div className="flex justify-center mb-4">
                            <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M3.6001 9H20.4001" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M3.6001 15H20.4001" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <h3 className="text-xl font-semibold mb-2">Engage Buyers from Anywhere</h3>
                            <p className="text-gray-600">Reach potential buyers with immersive 3D experiences that make property viewing accessible from anywhere</p>
                        </div>
                    </FadeIn>
                </div>

                <FadeIn delay={0.5}>
                    <div className="text-center mt-12">
                        <a href="/contact" className="inline-block px-8 py-3 bg-brand text-white font-semibold rounded-lg hover:bg-brand-dark transition-colors duration-200">
                            Book a Call
                        </a>
                    </div>
                </FadeIn>
            </div>

            <FadeIn delay={0.5}>
            <div className="relative w-full mt-8">
                <div className="flex w-full h-[400px]">
                    {/* first image */}
                    <div className="relative flex-1">
                        <picture>
                            <source media="(min-width: 768px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/hotel-resort01-500.jpg`} />
                            <source media="(max-width: 767px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/hotel-resort01-250.jpg`} />
                            <img 
                                src={`${process.env.PUBLIC_URL}/walkthrough/hotel-resort01-500.jpg`}
                                alt="Corporate architecture style"
                                className="w-full h-full object-cover"
                            />
                        </picture>
                    </div>

                    {/* second image */}
                    <div className="relative flex-1">
                        <picture>
                            <source media="(min-width: 768px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/hotel-resort02-500.jpg`} />
                            <source media="(max-width: 767px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/hotel-resort02-250.jpg`} />
                            <img 
                                src={`${process.env.PUBLIC_URL}/walkthrough/hotel-resort02-500.jpg`}
                                alt="Real estate development style"
                                className="w-full h-full object-cover"
                            />
                        </picture>
                    </div>

                    {/* third image */}
                    <div className="relative flex-1">
                        <picture>
                            <source media="(min-width: 768px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/hotel-resort03-500.jpg`} />
                            <source media="(max-width: 767px)" srcSet={`${process.env.PUBLIC_URL}/walkthrough/hotel-resort03-250.jpg`} />
                            <img 
                                src={`${process.env.PUBLIC_URL}/walkthrough/hotel-resort03-500.jpg`}
                                alt="City hall"
                                className="w-full h-full object-cover"
                            />
                        </picture>
                    </div>

                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-r from-brand/60 to-transparent"></div>

                    {/* Centered Text */}
                    <div className="absolute inset-0 flex items-center justify-center">
                        <h2 className="text-4xl font-bold text-white">hotels, resorts & restaurants</h2>
                    </div>
                </div>
            </div>
            </FadeIn>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Column 1 */}
                    <FadeIn delay={0.15}>
                    <div className="text-center">
                        <div className="flex justify-center mb-4">
                            <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 10L19.553 7.724C19.7054 7.64754 19.8748 7.60852 20.0466 7.61058C20.2184 7.61265 20.3867 7.65574 20.5373 7.73602C20.688 7.81631 20.817 7.93137 20.9141 8.07139C21.0112 8.21141 21.0735 8.37198 21.096 8.541L22 15.424C22.0239 15.6021 21.9984 15.7837 21.926 15.9492C21.8535 16.1147 21.7366 16.2584 21.5874 16.3667C21.4383 16.4751 21.2621 16.5443 21.0781 16.5676C20.8942 16.5908 20.7079 16.5673 20.538 16.499L16 15M15 10L12 8M15 10V16.799M12 8L8.447 5.724C8.29459 5.64754 8.12516 5.60852 7.95336 5.61058C7.78156 5.61265 7.61326 5.65574 7.46263 5.73602C7.312 5.81631 7.18299 5.93137 7.08591 6.07139C6.98882 6.21141 6.92648 6.37198 6.904 6.541L6 13.424C5.97609 13.6021 6.00165 13.7837 6.07405 13.9492C6.14645 14.1147 6.26337 14.2584 6.41256 14.3667C6.56175 14.4751 6.73794 14.5443 6.92191 14.5676C7.10587 14.5908 7.29215 14.5673 7.462 14.499L12 13M12 8V13M12 13L16 15M16 15V16.799M16 16.799L12.613 18.991C12.4311 19.1021 12.2181 19.1613 12 19.1613C11.7819 19.1613 11.5689 19.1021 11.387 18.991L8 16.799" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <h3 className="text-xl font-semibold mb-2">Captivate Guests with Virtual Tours</h3>
                        <p className="text-gray-600">Give prospective guests a taste of the atmosphere and luxury your property offers before they arrive</p>
                    </div>
                    </FadeIn>

                    {/* Column 2 */}
                    <FadeIn delay={0.3}>
                    <div className="text-center">
                        <div className="flex justify-center mb-4">
                            <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4 6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V18C20 18.5304 19.7893 19.0391 19.4142 19.4142C19.0391 19.7893 18.5304 20 18 20H6C5.46957 20 4.96086 19.7893 4.58579 19.4142C4.21071 19.0391 4 18.5304 4 18V6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M9 8H15M9 12H15M9 16H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <h3 className="text-xl font-semibold mb-2">Showcase Room Options and Amenities</h3>
                            <p className="text-gray-600">Let guests explore different room layouts, dining spaces, and amenities in stunning virtual detail</p>
                        </div>
                    </FadeIn>

                    {/* Column 3 */}
                    <FadeIn delay={0.45}>
                        <div className="text-center">
                            <div className="flex justify-center mb-4">
                                <svg className="w-16 h-16 text-brand" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">Drive Bookings with Immersive Experiences</h3>
                            <p className="text-gray-600">Enhance your marketing by providing guests with a virtual preview that builds anticipation and confidence</p>
                        </div>
                    </FadeIn>
                </div>

                <FadeIn delay={0.5}>
                    <div className="text-center mt-12">
                        <a href="/contact" className="inline-block px-8 py-3 bg-brand text-white font-semibold rounded-lg hover:bg-brand-dark transition-colors duration-200">
                            Book a Call
                        </a>
                    </div>
                </FadeIn>
            </div>
            
        </div>
        </>
    );
  }
  
  export default VirtualWalkthrough;